/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        $('[data-bg-img]').each(function() {
            $(this).css('background-image', 'url(' + $(this).data("bg-img") + ')');
        });

        jQuery("#menuzord").menuzord({
            align: "left",
            effect: "slide",
            animation: "none",
            indicatorFirstLevel: "<i class='fa fa-angle-down'></i>",
            indicatorSecondLevel: "<i class='fa fa-angle-right'></i>"
        });
        jQuery("#menuzord-right").menuzord({
            align: "right",
            effect: "slide",
            animation: "none",
            indicatorFirstLevel: "<i class='fa fa-angle-down'></i>",
            indicatorSecondLevel: "<i class='fa fa-angle-right'></i>"
        });
        jQuery("#menuzord-side-panel").menuzord({
            align: "right",
            effect: "slide",
            animation: "none",
            indicatorFirstLevel: "<i class='fa fa-angle-right'></i>",
            indicatorSecondLevel: "<i class='fa fa-angle-right'></i>"
        });

        jQuery("#menuzord-verticalnav").menuzord({
            align: "right",
            effect: "slide",
            animation: "none",
            indicatorFirstLevel: "<i class='fa fa-angle-right'></i>",
            indicatorSecondLevel: "<i class='fa fa-angle-right'></i>"
        });


        jQuery('.owl-carousel-4col').each(function() {
            var data_dots = ( jQuery(this).data("dots") === undefined ) ? false: jQuery(this).data("dots");
            var data_nav = ( jQuery(this).data("nav")=== undefined ) ? false: jQuery(this).data("nav");
            jQuery(this).owlCarousel({
                rtl: false,
                autoplay: true,
                autoplayTimeout: 8000,
                slideSpeed: 600,
                loop: false,
                items: 4,
                margin: 15,
                // dots: data_dots,
                dots: false,
                nav: data_nav,
                navText: [
                    '<i class="fa fa-angle-left"></i>',
                    '<i class="fa fa-angle-right"></i>'
                ],
                responsive: {
                    0: {
                        items: 1,
                        center: false
                    },
                    600: {
                        items: 1,
                        center: false
                    },
                    750: {
                        items: 2,
                        center: false
                    },
                    960: {
                        items: 3
                    },
                    1170: {
                        items: 4
                    },
                    1300: {
                        items: 4
                    }
                }
            });
        });


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS

        jQuery('.hp-causes').fadeIn(2000);


      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'dashboard': {
      init: function() {
        $('.get-cert-btn').on('click', function(event) {
          event.preventDefault();

          $('html, body').animate({
            scrollTop: $('.cert-section').offset().top - 20
          }, 500);
        });

        $('.add-hours-btn').on('click', function(event) {
          event.preventDefault();

          $('html, body').animate({
            scrollTop: $('.hours-form').offset().top - 20
          }, 500);
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/),
        function(i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, 'finalize');
        });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }

  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
